/*
 * Kompetenznachweis-Upload v3.1 – Upload auf der Produktseite (Theme-Datei assets/kn-upload.js).
 * Eingebunden von snippets/kn-upload.liquid (Markup, Adresse der Upload-App, Grenze in MB) mit
 * assets/kn-upload.css. Beschreibung der Schnittstelle: inc/seite-api.php der Upload-App, Ablauf: LIESMICH.md.
 *
 * Ein Knopf „PDF hochladen“ (Mehrfachauswahl); darunter die Liste der hochgeladenen Dateien mit Namen, Größe
 * und „entfernen“, dazu „2 von 3 Nachweisen · 4,1 von 20 MB“. Die Namen liefert die Upload-App (auch nach dem
 * Neuladen); im Browser wird nur die Kennung des Uploads gespeichert (sessionStorage).
 * „In den Warenkorb“ geht erst, wenn so viele PDFs da sind wie Karten gewählt – oder mit dem Häkchen
 * „… reiche ich nach dem Kauf nach“. Die Sperre läuft über setCustomValidity am (unsichtbaren) Dateifeld, das
 * per form-Attribut zum Warenkorb-Formular gehört; die Eigenschaften _kn_set, _kn_anzahl und Kompetenznachweis
 * gehen als versteckte Felder mit.
 */
(function () {
 'use strict';
 var KN = window.__knUpload3 = window.__knUpload3 || {};
 KN.seq = KN.seq || 0;

 var MB = 1048576;
 var MAX_KARTEN = 20;
 var ZEIT_UPLOAD = 180000;
 var ZEIT_KURZ = 30000;
 var FRIST = 600000;
 var SET_RE = /^[0-9a-f]{32}$/;
 var NEU_CODES = { zugeordnet: 1, abgelaufen: 1, unbekannt: 1 };
 /* Danach scheitern auch die naechsten Dateien: Warteschlange leeren. */
 var STOP_CODES = { zu_viele: 1, voll: 1, set_voll: 1, wartung: 1, netz: 1 };
 /* Danach kann die App die Datei trotzdem haben (Antwort verloren) oder mehr wissen als die Liste: Stand holen. */
 var NACHSEHEN = { netz: 1, zeit: 1, server: 1, technik: 1, gesamt_zu_gross: 1, set_voll: 1, doppelt: 1 };
 var TXT = {
  pflicht1: 'Bitte lade zuerst deinen Kompetenznachweis (PDF) hoch – ohne ihn können wir deine Karte nicht drucken.',
  pflicht1Spaeter: 'Bitte lade zuerst deinen Kompetenznachweis (PDF) hoch – oder setz unten das Häkchen, wenn du ihn nach dem Kauf nachreichst.',
  tippSpaeter: 'Klappt der Upload gerade nicht? Setz unten das Häkchen – dann kannst du trotzdem bestellen und den Nachweis nach dem Kauf über den Link in der Bestellbestätigung hochladen.',
  warten: 'Bitte warte, bis alle Nachweise fertig hochgeladen sind.',
  laden: 'Einen Moment – deine bisherigen Uploads werden geladen.',
  sendet: 'Einen Moment – der Artikel wird gerade in den Warenkorb gelegt.',
  spaeter1: 'Ich reiche meinen Kompetenznachweis nach dem Kauf nach (Link in der Bestellbestätigung)',
  spaeterN: 'Einen Teil der Nachweise reiche ich nach dem Kauf nach',
  nachKauf: 'Alles klar: Fehlende Nachweise lädst du nach dem Kauf über den Link in der Bestellbestätigung hoch. Wir drucken die Karten, sobald alle da sind.',
  zugeordnet: 'Deine bisherigen Uploads gehören schon zu einer Bestellung. Für diesen Artikel beginnen wir neu – bitte lade die Nachweise hier noch einmal hoch.',
  abgelaufen: 'Deine früheren Uploads waren älter als 3 Tage und wurden gelöscht. Bitte lade die Nachweise erneut hoch.',
  ladenFehler: 'Deine bisherigen Uploads konnten gerade nicht geladen werden. ',
  alt: 'Bitte klick noch einmal auf „In den Warenkorb“ – wir prüfen dann, ob deine Uploads noch da sind. Klappt das nicht, setz unten das Häkchen und reiche die Nachweise nach dem Kauf nach.',
  korbWeg: 'Achtung: Die Nachweise zum Artikel im Warenkorb sind bei uns nicht mehr vorhanden (ohne Bestellung nach 3 Tagen gelöscht). Bitte entferne ihn aus dem Warenkorb und lade sie hier noch einmal hoch – oder nach dem Kauf über den Link in der Bestellbestätigung.',
  /* Nur fuer Fehler ohne Text der App. */
  code: {
   zu_gross: 'Die Datei ist zu groß.',
   gesamt_zu_gross: 'Alle Nachweise zusammen wären zu groß.',
   netz: 'Der Upload hat nicht geklappt (keine Verbindung zum Upload-Server). Bitte versuch es noch einmal.',
   zeit: 'Das Hochladen hat zu lange gedauert. Bitte versuch es noch einmal.',
   server: 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuch es noch einmal.'
  }
 };

 function quote(name) { return '„' + name + '“'; }
 function karten(n) { return n + (n === 1 ? ' Karte' : ' Karten'); }

 function log(level, a, b) {
  try { if (window.console && console[level]) console[level]('[Kompetenznachweis]', a, b === undefined ? '' : b); } catch (e) {}
 }

 /* "1,2 MB" bzw. "340 KB" fuer einzelne Dateien. */
 function groesseText(b) {
  if (!(b > 0)) return '';
  if (b < MB) return Math.max(1, Math.round(b / 1024)) + ' KB';
  return (b / MB).toFixed(1).replace('.', ',') + ' MB';
 }

 /* Zahl fuer "4,1 von 20 MB": eine Nachkommastelle, ganze Zahlen ohne; nie "0,0" fuer eine kleine Datei. */
 function mbZahl(b) {
  if (!(b > 0)) return '0';
  var mb = Math.max(0.1, Math.round(b / MB * 10) / 10);
  return (mb % 1 === 0 ? String(mb) : mb.toFixed(1)).replace('.', ',');
 }

 function speicherLesen(key) {
  try {
   var raw = window.sessionStorage.getItem(key);
   var d = raw ? JSON.parse(raw) : null;
   return d && SET_RE.test(String(d.set)) ? d.set : '';
  } catch (e) { return ''; }
 }

 function speicherSchreiben(key, set) {
  try {
   if (set) window.sessionStorage.setItem(key, JSON.stringify({ set: set, zeit: Date.now() }));
   else window.sessionStorage.removeItem(key);
  } catch (e) {}
 }

 function findForm(root) {
  var scope = root.closest ? root.closest('.shopify-section') : null;
  var form = null;
  if (scope) {
   form = scope.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
    scope.querySelector('form[data-type="add-to-cart-form"]');
  }
  if (!form) {
   var all = document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]');
   if (all.length === 1) form = all[0];
  }
  return form;
 }

 function hideExpressFallback(root) {
  var hasSupport = false;
  try { hasSupport = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))')); } catch (e) {}
  if (hasSupport) return;
  var scope = root.closest ? root.closest('.shopify-section') : null;
  if (!scope) return;
  var els = scope.querySelectorAll('.accelerated-checkout-block, .shopify-payment-button, sticky-add-to-cart');
  for (var i = 0; i < els.length; i++) els[i].style.setProperty('display', 'none', 'important');
 }

 /* POST an die Upload-App, ohne Cookies und eigene Kopfzeilen (kein CORS-Vorabtest ausser fuer den Fortschritt). */
 function senden(url, felder, datei, zeit, fortschritt, fertig) {
  var done = false;
  function ende(r) { if (!done) { done = true; fertig(r); } }
  if (!url) { log('error', 'Keine Adresse der Upload-App eingestellt.'); ende({ http: 0, netz: true }); return; }
  try {
   var body = new FormData();
   for (var k in felder) if (Object.prototype.hasOwnProperty.call(felder, k)) body.append(k, felder[k]);
   if (datei) body.append('datei', datei.file, datei.name);
   var xhr = new XMLHttpRequest();
   xhr.open('POST', url, true);
   xhr.timeout = zeit;
   if (fortschritt && xhr.upload) {
    xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 0) fortschritt(e.loaded / e.total); };
   }
   xhr.onload = function () {
    var data = null;
    try { data = JSON.parse(xhr.responseText); } catch (e) {}
    ende({ http: xhr.status, data: data && typeof data === 'object' ? data : null, roh: xhr.responseText });
   };
   xhr.onerror = function () { ende({ http: 0, netz: true }); };
   xhr.onabort = function () { ende({ http: 0, netz: true }); };
   xhr.ontimeout = function () { ende({ http: 0, zeit: true }); };
   xhr.send(body);
  } catch (e) {
   log('error', e);
   ende({ http: 0, netz: true });
  }
 }

 function zahl(w) {
  var n = parseInt(w, 10);
  return n > 0 ? n : 0;
 }

 function dateienLesen(liste) {
  var out = [], seen = {};
  if (!liste || typeof liste.length !== 'number') return out;
  for (var i = 0; i < liste.length; i++) {
   var d = liste[i] || {};
   var p = parseInt(d.platz, 10);
   if (!(p >= 1 && p <= MAX_KARTEN) || seen[p]) continue;
   seen[p] = true;
   out.push({ platz: p, groesse: zahl(d.groesse), zeit: typeof d.zeit === 'string' ? d.zeit : '', name: typeof d.name === 'string' ? d.name.slice(0, 200) : '' });
  }
  out.sort(function (a, b) { return a.platz - b.platz; });
  return out;
 }

 function auswerten(r) {
  var d = r.data;
  if (d && d.ok === true && SET_RE.test(String(d.set || ''))) {
   /* Ablauf aus der Restzeit (die Uhr des Geraets kann falsch gehen). */
   var rest = parseInt(d.rest_sekunden, 10);
   var p = parseInt(d.platz, 10);
   return {
    ok: true, set: String(d.set), dateien: dateienLesen(d.dateien), zugeordnet: d.zugeordnet === true,
    ablauf: rest >= 0 ? Date.now() + rest * 1000 : 0, platz: p >= 1 && p <= MAX_KARTEN ? p : 0, maxGesamt: zahl(d.max_gesamt_bytes),
    ergebnis: typeof d.ergebnis === 'string' ? d.ergebnis : ''
   };
  }
  if (d && d.ok === false) {
   return { ok: false, code: String(d.code || 'server'), fehler: typeof d.fehler === 'string' ? d.fehler.slice(0, 400) : '', maxGesamt: zahl(d.max_gesamt_bytes) };
  }
  if (r.zeit) return { ok: false, code: 'zeit' };
  if (r.netz) return { ok: false, code: 'netz' };
  log('error', 'Unerwartete Antwort der Upload-App (HTTP ' + r.http + '):', String(r.roh || '').slice(0, 300));
  return { ok: false, code: r.http === 413 ? 'zu_gross' : 'server' };
 }

 function fehlerText(a) {
  return a.fehler || TXT.code[a.code] || TXT.code.server;
 }

 /* Liegt eine Mappe schon im Warenkorb? true/false, null = unbekannt. */
 function imWarenkorb(set, cb) {
  var basis = '/';
  try { if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') basis = Shopify.routes.root; } catch (e) {}
  if (typeof fetch !== 'function' || !set) { cb(null); return; }
  var fertig = false;
  var timer = setTimeout(function () { if (!fertig) { fertig = true; cb(null); } }, 8000);
  var request;
  try {
   request = fetch(basis + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
  } catch (e) {
   request = Promise.reject(e);
  }
  request.then(function (res) { return res.ok ? res.json() : null; }).then(function (cart) {
   if (!cart || !cart.items || typeof cart.items.length !== 'number') return null;
   for (var i = 0; i < cart.items.length; i++) {
    var p = cart.items[i] && cart.items[i].properties;
    if (p && p._kn_set === set) return true;
   }
   return false;
  }).catch(function () { return null; }).then(function (drin) {
   if (fertig) return;
   fertig = true;
   clearTimeout(timer);
   cb(drin);
  });
 }

 function setup(root) {
  if (!root || root.__kn) return;
  var list = root.querySelector('[data-kn-list]');
  var status = root.querySelector('[data-kn-status]');
  var fileInput = root.querySelector('[data-kn-file]');
  var wahlBtn = root.querySelector('[data-kn-wahl]');
  var propSet = root.querySelector('[data-kn-prop="set"]');
  var propAnzahl = root.querySelector('[data-kn-prop="anzahl"]');
  var propText = root.querySelector('[data-kn-prop="text"]');
  var api = root.getAttribute('data-kn-api') || '';
  if (!list || !status || !fileInput || !wahlBtn || !propSet || !propAnzahl || !propText) return;
  var label = root.querySelector('[data-kn-label]');
  var zaehler = root.querySelector('[data-kn-zaehler]');
  var tipp = root.querySelector('[data-kn-tipp]');
  var spaeter = root.querySelector('[data-kn-spaeter]');
  var spaeterBox = spaeter ? spaeter.querySelector('input[type="checkbox"]') : null;
  var spaeterText = root.querySelector('[data-kn-spaeter-text]');
  var nachreichen = root.querySelector('[data-kn-nachreichen]');
  var props = [propSet, propAnzahl, propText];
  var key = 'kn3-mappe-' + (root.getAttribute('data-kn-produkt') || 'x');
  var maxStandard = (parseInt(root.getAttribute('data-kn-max-mb'), 10) || 20) * MB;

  var form = findForm(root);
  if (form && form.__knRoot && form.__knRoot !== root && form.__knRoot.isConnected) {
   /* Zweites Upload-Feld fuer dasselbe Formular: Eigenschaften kaemen doppelt. */
   root.hidden = true;
   for (var j = 0; j < props.length; j++) { props[j].removeAttribute('form'); props[j].removeAttribute('name'); }
   fileInput.removeAttribute('form');
   log('warn', 'Zweites Upload-Feld fuer dasselbe Formular ausgeblendet.');
   return;
  }

  /* Nicht form.id: das Formular hat ein Feld name="id". */
  var formId = form ? (form.getAttribute('id') || '') : '';
  var uid = 'kn-' + (formId || 'upload').replace(/[^A-Za-z0-9_-]/g, '') + '-' + (++KN.seq);
  var st = root.__kn = {
   set: '', dateien: [], sigs: {}, jobs: [], aktiv: null, laden: false, unklar: false, versucht: false, linkOffen: false,
   n: 1, fehler: false, meldungen: [], grund: '', zeigeGrund: false, sendetBis: 0, lastInvalid: 0,
   ablauf: 0, bestaetigt: 0, maxGesamt: maxStandard, jobNr: 0
  };
  var rows = {};
  status.id = uid + '-status';
  fileInput.id = uid + '-file';
  if (label) {
   label.id = uid + '-label';
   fileInput.setAttribute('aria-labelledby', label.id);
   wahlBtn.setAttribute('aria-describedby', label.id);
  }

  function el(tag, cls, text) {
   var e = document.createElement(tag);
   if (cls) e.className = cls;
   if (text) e.textContent = text;
   return e;
  }

  function belegt(p) {
   for (var i = 0; i < st.dateien.length; i++) if (st.dateien[i].platz === p) return st.dateien[i];
   return null;
  }

  function alleJobs() { return st.aktiv ? [st.aktiv].concat(st.jobs) : st.jobs.slice(); }

  function uploadJobs() {
   var out = [], alle = alleJobs();
   for (var i = 0; i < alle.length; i++) if (alle[i].typ === 'hochladen') out.push(alle[i]);
   return out;
  }

  function entfernenJob(p) {
   var alle = alleJobs();
   for (var i = 0; i < alle.length; i++) if (alle[i].typ === 'entfernen' && alle[i].platz === p) return alle[i];
   return null;
  }

  function sichtbar() { return Math.min(Math.max(st.n, 1), MAX_KARTEN); }

  /* Hochgeladene PDFs ohne Auftrag "entfernen". Die Warteschlange laeuft strikt der Reihe nach: Was jetzt
     gewaehlt wird, geht erst nach dem Entfernen hinaus – zum Austauschen muss man das nicht abwarten. */
  function bleibend() {
   var out = [];
   for (var i = 0; i < st.dateien.length; i++) if (!entfernenJob(st.dateien[i].platz)) out.push(st.dateien[i]);
   return out;
  }

  /* Bytes der PDFs (ohne Warteschlange); ohne Liste aller hochgeladenen. */
  function belegtBytes(liste) {
   var s = 0;
   liste = liste || st.dateien;
   for (var i = 0; i < liste.length; i++) s += liste[i].groesse;
   return s;
  }

  /* Noch freie Nachweise bis zur gewaehlten Anzahl (bleibende und wartende zaehlen). */
  function frei() { return Math.max(0, sichtbar() - bleibend().length - uploadJobs().length); }

  /* Mehr PDFs als Karten: die letzten (nach Platz) sind "zu viel". */
  function extraPlaetze() {
   var belegte = [];
   for (var i = 0; i < st.dateien.length; i++) belegte.push(st.dateien[i].platz);
   belegte.sort(function (a, b) { return a - b; });
   return belegte.slice(sichtbar());
  }

  function beschaeftigt() { return !!(st.aktiv || st.jobs.length || st.laden); }

  /* Mappe (fast) abgelaufen, z. B. Seite tagelang offen, und nicht frisch bestaetigt: vor dem Warenkorb pruefen. */
  function veraltet() {
   var t = Date.now();
   return !!(st.set && st.dateien.length && st.ablauf && t > st.ablauf - FRIST && t - st.bestaetigt > 60000);
  }

  function auffrischen() {
   if (veraltet() && !beschaeftigt()) { st.meldungen = []; laden(st.set); }
  }

  /* Haekchen bei mehreren Karten, nach Fehlern, nach vergeblichem Klick und ueber "Nachweis nachreichen?";
     ausgeblendet zaehlt es nicht. */
  function spaeterSichtbar() { return st.n > 1 || st.fehler || st.unklar || st.versucht || st.linkOffen || veraltet(); }

  function spaeterAktiv() { return !!(spaeter && spaeterBox && spaeterSichtbar() && spaeterBox.checked); }

  function zuvielText() {
   var k = st.dateien.length, n = sichtbar();
   if (k <= n) return '';
   return 'Du hast ' + karten(n) + ' gewählt, aber ' + k + ' Nachweise hochgeladen. Entferne ' + (k - n === 1 ? 'einen davon' : (k - n) + ' davon') + ' oder erhöhe die Anzahl auf ' + k + '.';
  }

  function mengeFeld() {
   var q = null;
   try { q = form && form.elements ? form.elements.namedItem('quantity') : null; } catch (e) {}
   if (q && !q.tagName && q.length) q = q[0];
   return q && q.tagName ? q : null;
  }

  function mengeLesen() {
   var q = mengeFeld();
   var n = q ? parseInt(q.value, 10) : 1;
   return n >= 1 ? n : 1;
  }

  /* Menge setzen wie von Hand: Horizon uebernimmt sie beim blur und prueft Min./Max. */
  function mengeSetzen(z) {
   var q = mengeFeld();
   if (!q) return;
   try {
    q.value = String(z);
    q.dispatchEvent(new Event('input', { bubbles: true }));
    q.dispatchEvent(new Event('change', { bubbles: true }));
    q.dispatchEvent(new FocusEvent('blur'));
   } catch (e) { log('warn', e); }
   aktualisieren();
  }

  function mengeKnopf() {
   var k = st.dateien.length;
   if (!mengeFeld() || k <= sichtbar()) return null;
   return { label: 'Anzahl auf ' + k + ' setzen', fn: function () { if (!beschaeftigt()) mengeSetzen(k); } };
  }

  /* datei: zu einem Upload-Fehler, nach dem die Datei trotzdem angekommen sein kann (siehe uebernehmen). */
  function meldung(state, text, knopf, datei) { st.meldungen.push({ state: state, text: text, knopf: knopf || null, datei: datei || null }); }

  /* "Schon fuer alle Karten …" (Klick auf den Knopf): gilt nur bis zum Ende des naechsten Auftrags (siehe fertig). */
  function hinweisVoll(text) { st.meldungen.push({ state: 'idle', text: text, knopf: null, datei: null, voll: true }); }

  function setProp(input, value) {
   input.value = value;
   input.disabled = value === '';
  }

  /* Einzige Stelle fuer Eigenschaften und Pflichtpruefung (setCustomValidity). */
  function anwenden() {
   var n = st.n, k = st.dateien.length, alt = veraltet(), msg = '';
   if (st.laden) msg = TXT.laden;
   else if (beschaeftigt()) msg = TXT.warten;
   else if (Date.now() < st.sendetBis) msg = TXT.sendet;
   else if (alt) { if (!spaeterAktiv()) msg = TXT.alt; }
   else if (zuvielText()) msg = zuvielText();
   else if (k < n && !spaeterAktiv()) {
    msg = n === 1 ? (spaeterSichtbar() ? TXT.pflicht1Spaeter : TXT.pflicht1) : 'Bitte lade für jede Karte einen Kompetenznachweis hoch (' + k + ' von ' + n + ' hochgeladen) – oder setz unten das Häkchen, wenn du einen Teil nach dem Kauf nachreichst.';
   }
   /* Mappe evtl. weg: nichts verknuepfen. */
   if (alt) k = 0;
   setProp(propSet, k > 0 && !st.unklar ? st.set : '');
   setProp(propAnzahl, String(k));
   setProp(propText, k > 0 ? k + ' von ' + n + ' PDF hochgeladen' + (k < n ? ' – Rest folgt nach dem Kauf' : '') : 'folgt nach dem Kauf');
   try { fileInput.setCustomValidity(msg); } catch (e) {}
   if (msg !== st.grund) {
    st.zeigeGrund = false;
    root.classList.remove('is-invalid');
   }
   st.grund = msg;
  }

  /* Eine Zeile der Liste: Symbol, Name, Groesse bzw. Fortschritt, "entfernen". */
  function zeileAnlegen(schluessel) {
   var li = el('li', 'kn-upload__row');
   var icon = el('span', 'kn-upload__icon');
   icon.setAttribute('aria-hidden', 'true');
   var info = el('div', 'kn-upload__info');
   var name = el('span', 'kn-upload__name');
   var meta = el('span', 'kn-upload__meta');
   var balken = el('progress', 'kn-upload__balken');
   balken.max = 100;
   balken.hidden = true;
   info.appendChild(name);
   info.appendChild(meta);
   info.appendChild(balken);
   var weg = el('button', 'kn-upload__weg', 'entfernen');
   weg.type = 'button';
   weg.addEventListener('click', function () { if (rows[schluessel] && rows[schluessel].platz) entfernenAnfordern(rows[schluessel].platz); });
   li.appendChild(icon);
   li.appendChild(info);
   li.appendChild(weg);
   return { li: li, icon: icon, name: name, meta: meta, balken: balken, weg: weg, platz: 0 };
  }

  function dateiZeichnen(z, d, nr, extra) {
   var job = entfernenJob(d.platz), anzeige = d.name || 'Nachweis ' + nr;
   /* Zahl und Einheit nicht trennen (schmale Bildschirme). */
   var state = job ? 'busy' : (extra ? 'extra' : 'ok'), text = groesseText(d.groesse).replace(' ', ' ');
   if (job) text = (text ? text + ' · ' : '') + (job === st.aktiv ? 'wird entfernt …' : 'wird gleich entfernt …');
   else if (extra) text = (text ? text + ' · ' : '') + 'mehr als die gewählte Anzahl';
   z.platz = d.platz;
   z.li.setAttribute('data-state', state);
   z.icon.textContent = state === 'ok' ? '✓' : (state === 'extra' ? '!' : '');
   z.name.textContent = anzeige;
   z.meta.textContent = text ? ' · ' + text : '';
   z.balken.hidden = true;
   z.weg.hidden = false;
   z.weg.disabled = !!job || st.laden;
   z.weg.setAttribute('aria-label', anzeige + ' entfernen');
  }

  function jobZeichnen(z, job) {
   var text, pct = -1;
   if (job === st.aktiv) {
    pct = Math.round((job.fortschritt || 0) * 100);
    text = pct >= 100 ? 'wird geprüft …' : 'wird hochgeladen … ' + pct + ' %';
   } else {
    text = 'wartet …';
   }
   z.platz = 0;
   z.li.setAttribute('data-state', 'busy');
   z.icon.textContent = '';
   z.name.textContent = job.name;
   z.meta.textContent = ' · ' + text;
   z.balken.hidden = pct < 0;
   if (pct >= 0) z.balken.value = Math.min(pct, 100);
   z.weg.hidden = true;
  }

  function statusZeichnen() {
   var teile = [], i, n = st.n, k = st.dateien.length;
   for (i = 0; i < st.meldungen.length; i++) teile.push(st.meldungen[i]);
   if (st.zeigeGrund && st.grund) {
    teile.push(st.grund === zuvielText()
     ? { state: 'error', text: st.grund + ' ', knopf: mengeKnopf() }
     : { state: beschaeftigt() ? 'busy' : 'error', text: st.grund });
   } else if (st.laden) {
    teile.push({ state: 'busy', text: 'Deine bisherigen Uploads werden geladen …' });
   } else if (st.aktiv) {
    teile.push({ state: 'busy', text: (st.aktiv.typ === 'entfernen' ? 'Wird entfernt …' : (st.aktiv.typ === 'status' ? 'Wir prüfen, was angekommen ist …' : 'Wird hochgeladen …')) + (st.jobs.length ? ' (danach noch ' + st.jobs.length + ')' : '') });
   } else if (veraltet()) {
    teile.push({ state: 'idle', text: spaeterAktiv() ? TXT.nachKauf : TXT.alt });
   } else if (zuvielText()) {
    teile.push({ state: 'error', text: zuvielText() + ' ', knopf: mengeKnopf() });
   } else if (k >= n && k > 0) {
    teile.push({ state: 'ok', text: (n === 1 ? 'Dein Nachweis ist hochgeladen ✓' : 'Alle ' + n + ' Nachweise sind hochgeladen ✓') + ' Du kannst jetzt in den Warenkorb legen.' });
   } else {
    teile.push({ state: 'idle', text: k === 0 ? (n === 1 ? 'Noch kein Nachweis hochgeladen.' : 'Noch keine Nachweise hochgeladen.') : 'Noch ' + (n - k) + (n - k === 1 ? ' Nachweis fehlt.' : ' Nachweise fehlen.') });
    if (spaeterAktiv()) teile.push({ state: 'ok', text: TXT.nachKauf });
    else if (st.fehler && spaeterSichtbar() && !beschaeftigt()) teile.push({ state: 'idle', text: TXT.tippSpaeter });
   }
   if (st.n > MAX_KARTEN) teile.push({ state: 'idle', text: 'Hier kannst du bis zu ' + MAX_KARTEN + ' Nachweise hochladen – den Rest bitte nach dem Kauf.' });
   status.textContent = '';
   for (i = 0; i < teile.length; i++) {
    var t = teile[i];
    if (!t.text) continue;
    var span = el('span', 'kn-upload__msg', t.text);
    span.setAttribute('data-state', t.state);
    if (t.knopf) {
     var b = el('button', '', t.knopf.label);
     b.type = 'button';
     b.addEventListener('click', t.knopf.fn);
     span.appendChild(b);
    }
    status.appendChild(span);
   }
  }

  function zeichnen() {
   var extra = extraPlaetze(), jobs = uploadJobs(), soll = [], vor = list.firstChild, i, s, z;
   for (i = 0; i < st.dateien.length; i++) soll.push({ key: 'p' + st.dateien[i].platz, d: st.dateien[i], nr: i + 1 });
   for (i = 0; i < jobs.length; i++) soll.push({ key: 'j' + jobs[i].nr, job: jobs[i] });
   var aktiv = {};
   for (i = 0; i < soll.length; i++) {
    s = soll[i];
    aktiv[s.key] = true;
    z = rows[s.key] || (rows[s.key] = zeileAnlegen(s.key));
    /* Reihenfolge: Dateien nach Platz, dann die Warteschlange; nur verschieben, wenn noetig. */
    if (z.li !== vor) list.insertBefore(z.li, vor);
    else vor = vor.nextSibling;
    if (s.d) dateiZeichnen(z, s.d, s.nr, extra.indexOf(s.d.platz) !== -1); else jobZeichnen(z, s.job);
   }
   for (var schluessel in rows) {
    if (Object.prototype.hasOwnProperty.call(rows, schluessel) && !aktiv[schluessel]) {
     if (rows[schluessel].li.parentNode === list) list.removeChild(rows[schluessel].li);
     delete rows[schluessel];
    }
   }
   list.hidden = soll.length === 0;
   wahlBtn.hidden = false;
   wahlBtn.disabled = st.laden;
   if (zaehler) {
    zaehler.hidden = false;
    zaehler.textContent = st.dateien.length + ' von ' + st.n + (st.n === 1 ? ' Nachweis' : ' Nachweisen') + ' · ' + mbZahl(belegtBytes()) + ' von ' + mbZahl(st.maxGesamt) + ' MB';
   }
   if (spaeter) {
    if (!spaeterSichtbar() && spaeterBox) spaeterBox.checked = false;
    spaeter.hidden = !spaeterSichtbar();
    if (spaeterText) spaeterText.textContent = st.n > 1 ? TXT.spaeterN : TXT.spaeter1;
   }
   if (nachreichen) nachreichen.hidden = !spaeter || spaeterSichtbar() || st.n !== 1 || st.dateien.length > 0 || uploadJobs().length > 0;
   if (tipp) tipp.hidden = st.laden || frei() < 2;
   statusZeichnen();
  }

  function aktualisieren() {
   st.n = mengeLesen();
   anwenden();
   zeichnen();
  }

  /* Stand der App uebernehmen. eigener = Platz der Datei, deren Antwort das ist (zaehlt nicht als "neu"). */
  function uebernehmen(a, eigener) {
   var bekannt = {}, i, j;
   for (i = 0; i < st.dateien.length; i++) bekannt[st.dateien[i].platz + '|' + st.dateien[i].zeit] = true;
   st.set = a.set;
   st.dateien = a.dateien;
   st.unklar = false;
   st.ablauf = a.ablauf;
   st.bestaetigt = Date.now();
   if (a.maxGesamt) st.maxGesamt = a.maxGesamt;
   speicherSchreiben(key, a.set);
   for (var p in st.sigs) if (Object.prototype.hasOwnProperty.call(st.sigs, p) && !belegt(+p)) delete st.sigs[p];
   /* Neu in der Liste und gleich gross wie eine Datei mit Fehlermeldung: Sie ist doch angekommen (Antwort verloren). */
   for (i = 0; i < a.dateien.length; i++) {
    var d = a.dateien[i];
    if (d.platz === eigener || bekannt[d.platz + '|' + d.zeit]) continue;
    for (j = 0; j < st.meldungen.length; j++) {
     var m = st.meldungen[j];
     if (m.datei && m.datei.groesse === d.groesse) {
      st.meldungen[j] = { state: 'ok', text: quote(m.datei.name) + ' ist doch angekommen.', knopf: null, datei: null };
      st.sigs[d.platz] = m.datei.sig;
      break;
     }
    }
   }
  }

  function neuBeginnen() {
   st.set = '';
   st.dateien = [];
   st.sigs = {};
   st.unklar = false;
   st.ablauf = 0;
   speicherSchreiben(key, '');
  }

  function weiter() {
   if (!root.isConnected) return;
   if (st.aktiv || st.laden) { anwenden(); zeichnen(); return; }
   var job = st.jobs.shift();
   if (job) {
    st.aktiv = job;
    job.fortschritt = 0;
    if (job.typ === 'hochladen') hochladen(job); else if (job.typ === 'status') nachsehen(); else entfernen(job);
   }
   anwenden();
   zeichnen();
  }

  function fertig() {
   st.aktiv = null;
   /* Der Stand hat sich geaendert: Hinweise aus waehlen() waeren jetzt ueberholt. */
   st.meldungen = st.meldungen.filter(function (m) { return !m.voll; });
   weiter();
  }

  function hochladen(job) {
   var gesendet = st.set;
   /* Ohne Platz: die App legt die PDF auf den ersten freien Platz (nichts wird ueberschrieben). */
   var felder = { aktion: 'hochladen' };
   if (gesendet) felder.set = gesendet;
   senden(api, felder, { file: job.datei, name: job.name }, ZEIT_UPLOAD, function (anteil) {
    job.fortschritt = anteil;
    if (st.aktiv === job && rows['j' + job.nr]) jobZeichnen(rows['j' + job.nr], job);
   }, function (r) {
    if (!root.isConnected) return;
    var a = auswerten(r);
    if (a.ok && a.zugeordnet) a = { ok: false, code: 'zugeordnet', fehler: '' };
    if (a.ok) {
     if (gesendet && a.set !== gesendet && st.dateien.length) meldung('error', TXT.abgelaufen);
     /* gleich: Diese PDF lag schon in der Mappe (die App aendert nichts). */
     var schon = a.ergebnis === 'gleich' && a.set === gesendet ? belegt(a.platz) : null;
     uebernehmen(a, a.platz);
     if (schon) {
      st.fehler = true;
      meldung('error', quote(job.name) + ' wurde nicht hochgeladen. Diese PDF hast du schon hochgeladen' + (schon.name ? ' (' + quote(schon.name) + ')' : '') + '. Für jede Karte brauchen wir den Kompetenznachweis der jeweiligen Person.');
     } else {
      /* Nicht in der Liste: Die Antwort auf einen frueheren Versuch ging verloren. */
      if (a.ergebnis === 'gleich') meldung('ok', quote(job.name) + ' ist schon angekommen.');
      if (a.platz && belegt(a.platz)) st.sigs[a.platz] = job.sig;
     }
    } else if (NEU_CODES[a.code] && gesendet && !job.neu) {
     /* Mappe bestellt oder abgelaufen: neue Mappe, Datei noch einmal senden. */
     var hatte = st.dateien.length > 0;
     neuBeginnen();
     if (a.code === 'zugeordnet') meldung('error', TXT.zugeordnet);
     else if (hatte) meldung('error', a.fehler || TXT.abgelaufen);
     job.neu = true;
     job.fortschritt = 0;
     hochladen(job);
     return;
    } else {
     var pruefen = !!(gesendet && NACHSEHEN[a.code]);
     st.fehler = true;
     if (a.maxGesamt) st.maxGesamt = a.maxGesamt;
     meldung('error', quote(job.name) + ' wurde nicht hochgeladen. ' + fehlerText(a), null, pruefen ? { name: job.name, groesse: job.datei.size, sig: job.sig } : null);
     if (STOP_CODES[a.code]) {
      var rest = 0;
      for (var m = st.jobs.length - 1; m >= 0; m--) if (st.jobs[m].typ === 'hochladen') { st.jobs.splice(m, 1); rest++; }
      if (rest) meldung('error', rest === 1 ? 'Eine weitere Datei wurde deshalb nicht gesendet.' : rest + ' weitere Dateien wurden deshalb nicht gesendet.');
     }
     /* Stand holen, sobald die Warteschlange abgearbeitet ist (einmal). */
     if (pruefen && !st.jobs.some(function (x) { return x.typ === 'status'; })) st.jobs.push({ typ: 'status', nr: ++st.jobNr, platz: 0, sig: '' });
    }
    fertig();
   });
  }

  /* Nach einem Fehler den Stand der Mappe still nachfragen: Liste, Zaehler und Eigenschaften folgen der App.
     Scheitert die Frage, bleibt alles, wie es ist. */
  function nachsehen() {
   var set = st.set;
   if (!set) { fertig(); return; }
   senden(api, { aktion: 'status', set: set }, null, ZEIT_KURZ, null, function (r) {
    if (!root.isConnected) return;
    var a = auswerten(r);
    if (a.ok && !a.zugeordnet) {
     uebernehmen(a);
    } else if (a.ok || NEU_CODES[a.code]) {
     neuBeginnen();
     meldung('error', a.ok || a.code === 'zugeordnet' ? TXT.zugeordnet : (a.fehler || TXT.abgelaufen));
    } else {
     log('warn', 'Stand der Uploads nach dem Fehler nicht abrufbar (' + a.code + ').');
    }
    fertig();
   });
  }

  function entfernen(job) {
   if (!st.set) { fertig(); return; }
   var d = belegt(job.platz), name = d && d.name ? d.name : 'Der Nachweis';
   senden(api, { aktion: 'entfernen', set: st.set, platz: String(job.platz) }, null, ZEIT_KURZ, null, function (r) {
    if (!root.isConnected) return;
    var a = auswerten(r);
    if (a.ok && a.zugeordnet) a = { ok: false, code: 'zugeordnet', fehler: '' };
    if (a.ok) {
     uebernehmen(a);
     delete st.sigs[job.platz];
    } else if (NEU_CODES[a.code]) {
     neuBeginnen();
     meldung('error', a.code === 'zugeordnet' ? TXT.zugeordnet : (a.fehler || TXT.abgelaufen));
    } else {
     meldung('error', (d && d.name ? quote(d.name) : name) + ' konnte nicht entfernt werden. ' + fehlerText(a));
    }
    fertig();
   });
  }

  function pruefen(file) {
   var name = file.name || 'Datei';
   var lower = name.toLowerCase();
   var isPdf = file.type === 'application/pdf' || /\.pdf$/.test(lower);
   if (!isPdf || /\.php$/.test(lower) || lower.indexOf('.php.') !== -1) return quote(name) + ' ist keine PDF-Datei. Bitte wähle den Kompetenznachweis als PDF aus.';
   if (!file.size) return quote(name) + ' ist leer. Bitte wähle eine andere PDF-Datei.';
   if (file.size > st.maxGesamt) return quote(name) + ' ist größer als ' + mbZahl(st.maxGesamt) + ' MB – mehr dürfen alle Nachweise zusammen nicht haben.';
   return '';
  }

  /* Dieselbe Datei (Name, Groesse, Datum) schon hochgeladen (und nicht gerade entfernt) oder in der Warteschlange? */
  function sigBekannt(sig) {
   for (var p in st.sigs) if (Object.prototype.hasOwnProperty.call(st.sigs, p) && st.sigs[p] === sig && belegt(+p) && !entfernenJob(+p)) return true;
   var jobs = uploadJobs();
   for (var i = 0; i < jobs.length; i++) if (jobs[i].sig === sig) return true;
   return false;
  }

  function waehlen() {
   if (st.laden) return;
   st.n = mengeLesen();
   if (frei() === 0) {
    /* Alle Karten haben schon einen Nachweis (oder einen in der Warteschlange): nicht erst den Dialog oeffnen. */
    st.meldungen = [];
    if (uploadJobs().length) hinweisVoll('Für alle Karten ist schon eine Datei gewählt – sie wird gerade hochgeladen.');
    else if (bleibend().length > sichtbar()) { /* "zu viel": die Meldung mit "Anzahl auf … setzen" steht schon da */ }
    else if (st.n === 1) hinweisVoll('Dein Nachweis ist schon hochgeladen. Zum Austauschen entferne ihn und lade den neuen hoch.');
    else hinweisVoll('Für alle ' + karten(sichtbar()) + ' ist schon ein Nachweis da. Zum Austauschen entferne einen und lade den neuen hoch – für mehr Karten erhöhe zuerst die Anzahl.');
    anwenden();
    zeichnen();
    return;
   }
   fileInput.multiple = frei() > 1;
   try { fileInput.click(); } catch (e) {}
  }

  function onPick() {
   var files = fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
   try { fileInput.value = ''; } catch (e) {}
   if (!files.length || st.laden) return;
   st.n = mengeLesen();
   st.meldungen = [];
   /* Dateien, die gerade entfernt werden, zaehlen nicht mehr: Die Warteschlange entfernt sie vorher. */
   var platzFrei = frei(), zuViel = 0, summe = belegtBytes(bleibend()), i;
   var jobs = uploadJobs();
   for (i = 0; i < jobs.length; i++) summe += jobs[i].datei.size || 0;
   for (i = 0; i < files.length; i++) {
    var f = files[i], name = f.name || 'Datei', sig = [f.name, f.size, f.lastModified].join('|');
    var fehler = pruefen(f);
    /* Falsche oder zu grosse Datei: wie bei Fehlern der App das Haekchen "nachreichen" anbieten. */
    if (fehler) st.fehler = true;
    else if (sigBekannt(sig)) fehler = quote(name) + ' ist schon hochgeladen.';
    if (fehler) { meldung('error', fehler); continue; }
    if (platzFrei <= 0) { zuViel++; continue; }
    if (summe + f.size > st.maxGesamt) {
     meldung('error', quote(name) + ' (' + groesseText(f.size) + ') passt nicht mehr dazu: Alle Nachweise zusammen dürfen höchstens ' + mbZahl(st.maxGesamt) + ' MB groß sein (bisher ' + mbZahl(summe) + ' MB). Entferne eine Datei oder reiche diesen Nachweis nach dem Kauf über den Link in der Bestellbestätigung nach.');
     st.fehler = true;
     continue;
    }
    summe += f.size;
    platzFrei--;
    st.jobs.push({ typ: 'hochladen', nr: ++st.jobNr, datei: f, name: name, sig: sig });
   }
   if (zuViel > 0) {
    meldung('error', (zuViel === 1 ? 'Eine Datei wurde' : zuViel + ' Dateien wurden') + ' nicht hochgeladen: Du hast ' + karten(st.n) + ' gewählt' + (st.n > MAX_KARTEN ? ' (hier höchstens ' + MAX_KARTEN + ')' : '') + '. Erhöhe die Anzahl, wenn du mehr Karten bestellen möchtest.');
   }
   weiter();
  }

  function entfernenAnfordern(p) {
   if (st.laden || !belegt(p) || entfernenJob(p)) return;
   st.meldungen = [];
   st.jobs.push({ typ: 'entfernen', nr: ++st.jobNr, platz: p, sig: '' });
   weiter();
   /* Fokus nicht verlieren, wenn die Zeile gleich verschwindet. */
   try { wahlBtn.focus({ preventScroll: true }); } catch (e) {}
  }

  /* Mappe im Warenkorb melden (bleibt dann 14 statt 3 Tage). Ist sie weg, muss man das sehen. */
  function warenkorbMelden(set, nochmal) {
   if (!set) return;
   senden(api, { aktion: 'warenkorb', set: set }, null, ZEIT_KURZ, null, function (r) {
    var a = auswerten(r);
    if (a.ok) return;
    log('warn', 'Warenkorb-Meldung an die Upload-App fehlgeschlagen (' + a.code + ').');
    if ((a.code === 'netz' || a.code === 'zeit') && !nochmal) setTimeout(function () { warenkorbMelden(set, true); }, 5000);
    if (a.code === 'unbekannt' && root.isConnected) {
     st.meldungen = [];
     meldung('error', TXT.korbWeg);
     zeichnen();
    }
   });
  }

  function imWarenkorbGelegt() {
   var k = st.dateien.length;
   warenkorbMelden(st.set);
   neuBeginnen();
   st.fehler = false;
   st.versucht = false;
   if (spaeterBox) spaeterBox.checked = false;
   st.meldungen = [];
   meldung('ok', 'Im Warenkorb: ' + (k === 1 ? 'Dein Nachweis ist' : 'Deine ' + k + ' Nachweise sind') + ' mit dem Artikel im Warenkorb verknüpft. Für weitere Führerscheine lade hier die nächsten Nachweise hoch.');
   aktualisieren();
  }

  function warenkorbPruefen(set) {
   if (!set || st.set !== set || !st.dateien.length) return;
   imWarenkorb(set, function (drin) {
    if (drin === true && root.isConnected && st.set === set && !beschaeftigt()) imWarenkorbGelegt();
   });
  }

  /* Stand holen: beim Start und vor dem Warenkorb, wenn veraltet. */
  function laden(vorgabe) {
   var gespeichert = vorgabe || speicherLesen(key);
   if (!gespeichert) return;
   st.set = gespeichert;
   st.laden = true;
   st.meldungen = [];
   aktualisieren();
   imWarenkorb(gespeichert, function (drin) {
    if (!root.isConnected) return;
    if (drin === true) {
     /* Liegt schon im Warenkorb: fuer den naechsten Artikel neu beginnen. */
     warenkorbMelden(gespeichert);
     neuBeginnen();
     st.laden = false;
     meldung('ok', 'Deine bisherigen Nachweise sind mit dem Artikel im Warenkorb verknüpft. Für weitere Führerscheine lade hier die nächsten Nachweise hoch.');
     weiter();
     return;
    }
    senden(api, { aktion: 'status', set: gespeichert }, null, ZEIT_KURZ, null, function (r) {
     if (!root.isConnected) return;
     var a = auswerten(r);
     st.laden = false;
     if (a.ok && !a.zugeordnet) {
      uebernehmen(a);
     } else if (a.ok || NEU_CODES[a.code]) {
      /* Bestellt: still neu beginnen; unbekannt: geloescht. */
      neuBeginnen();
      if (!a.ok && a.code !== 'zugeordnet') meldung('error', a.fehler || TXT.abgelaufen);
     } else {
      st.unklar = true;
      meldung('error', TXT.ladenFehler + fehlerText(a) + ' ', { label: 'Erneut versuchen', fn: function () { if (!beschaeftigt()) { st.meldungen = []; laden(st.set); } } });
     }
     weiter();
    });
   });
  }

  function onInvalid(event) {
   /* Statt Browser-Blase: eigene Meldung, Feld anscrollen. */
   if (event && event.preventDefault) event.preventDefault();
   if (!st.versucht && !beschaeftigt() && Date.now() >= st.sendetBis && st.dateien.length < sichtbar()) {
    /* Erster vergeblicher Klick: ab jetzt das Haekchen zeigen. */
    st.versucht = true;
    anwenden();
    zeichnen();
   }
   st.zeigeGrund = true;
   if (st.grund === TXT.sendet) { statusZeichnen(); return; }
   root.classList.add('is-invalid');
   statusZeichnen();
   var now = Date.now();
   if (now - st.lastInvalid < 800) return;
   st.lastInvalid = now;
   setTimeout(function () {
    var smooth = true;
    try { smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    try { root.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' }); } catch (e) { try { root.scrollIntoView(); } catch (e2) {} }
    var ziel = null, extra = extraPlaetze();
    if (extra.length && rows['p' + extra[0]]) ziel = rows['p' + extra[0]].weg;
    else if (!wahlBtn.hidden) ziel = wahlBtn;
    try { if (ziel && !ziel.disabled) ziel.focus({ preventScroll: true }); } catch (e) {}
   }, 0);
  }

  function gehoertZumFormular(t) {
   return !!(form && t && (t === form || (t.nodeType === 1 && form.contains(t)) || t.form === form));
  }

  function abmelden() {
   document.removeEventListener('input', onMenge, true);
   document.removeEventListener('change', onMenge, true);
   document.removeEventListener('quantity-selector:update', onMenge, true);
   document.removeEventListener('click', onKlick, true);
   document.removeEventListener('submit', onSubmit, true);
   document.removeEventListener('visibilitychange', onSichtbar);
   window.removeEventListener('pageshow', onPageshow);
  }

  function onMenge(e) {
   if (!root.isConnected) { abmelden(); return; }
   if (!gehoertZumFormular(e.target) || e.target === fileInput) return;
   setTimeout(function () { if (root.isConnected && mengeLesen() !== st.n) aktualisieren(); }, 0);
  }

  function onKlick(e) {
   if (!root.isConnected) { abmelden(); return; }
   var t = e.target && e.target.closest ? e.target.closest('button, input') : null;
   if (!gehoertZumFormular(t)) return;
   /* Menge frisch lesen (+/- aendern sie erst danach). Veraltete Mappe pruefen (sperrt bis zur Antwort),
      ausser nach gescheiterter Pruefung mit Haekchen. */
   if (t.type === 'submit') { st.n = mengeLesen(); if (!st.unklar || !spaeterAktiv()) auffrischen(); anwenden(); zeichnen(); }
   setTimeout(function () { if (root.isConnected && mengeLesen() !== st.n) aktualisieren(); }, 0);
  }

  function onSubmit(e) {
   if (!root.isConnected) { abmelden(); return; }
   if (e.target !== form) return;
   /* Pruefung bestanden: Doppelklick sperren; liegt die Mappe im Warenkorb, bekommt der naechste Artikel eine neue. */
   st.sendetBis = Date.now() + 2500;
   anwenden();
   setTimeout(function () { if (root.isConnected) anwenden(); }, 2600);
   var set = st.set;
   if (!set || !st.dateien.length) return;
   setTimeout(function () { warenkorbPruefen(set); }, 1500);
   setTimeout(function () { warenkorbPruefen(set); }, 4000);
   setTimeout(function () { warenkorbPruefen(set); }, 9000);
  }

  function onPageshow(e) {
   if (!root.isConnected) { abmelden(); return; }
   if (e && e.persisted) warenkorbPruefen(st.set);
   auffrischen();
  }

  function onSichtbar() {
   if (!root.isConnected) { abmelden(); return; }
   if (document.visibilityState === 'visible') auffrischen();
  }

  wahlBtn.addEventListener('click', waehlen);
  fileInput.addEventListener('change', onPick);
  fileInput.addEventListener('invalid', onInvalid);
  if (spaeterBox) {
   spaeterBox.addEventListener('change', function () {
    st.meldungen = [];
    anwenden();
    zeichnen();
   });
  }
  if (nachreichen) {
   nachreichen.addEventListener('click', function () {
    st.linkOffen = true;
    anwenden();
    zeichnen();
    try { if (spaeterBox) spaeterBox.focus(); } catch (e) {}
   });
  }
  document.addEventListener('input', onMenge, true);
  document.addEventListener('change', onMenge, true);
  document.addEventListener('quantity-selector:update', onMenge, true);
  document.addEventListener('click', onKlick, true);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('visibilitychange', onSichtbar);
  window.addEventListener('pageshow', onPageshow);

  /* Vom Browser beim Zurueckblaettern wiederhergestellte Werte verwerfen. */
  if (spaeterBox) spaeterBox.checked = false;

  if (form) {
   /* Reste frueherer Instanzen (Theme-Editor) entfernen. */
   var stale = form.querySelectorAll('input[data-kn-prop]');
   for (var i = 0; i < stale.length; i++) {
    if (!root.contains(stale[i]) && stale[i].parentNode) stale[i].parentNode.removeChild(stale[i]);
   }
   form.__knRoot = root;
   if (!formId) {
    formId = uid + '-form';
    form.setAttribute('id', formId);
   }
   fileInput.setAttribute('form', formId);
   for (var m = 0; m < props.length; m++) {
    props[m].setAttribute('form', formId);
    /* Browser ohne form-Attribut: Feld verschieben. */
    if (props[m].form !== form) form.appendChild(props[m]);
   }
   hideExpressFallback(root);
  } else {
   log('warn', 'Warenkorb-Formular nicht gefunden - die Nachweise werden nicht mit der Bestellung verknuepft.');
  }
  if (!api) log('error', 'Keine Adresse der Upload-App eingestellt.');
  aktualisieren();
  laden();
 }

 KN.initAll = function () {
  var roots = document.querySelectorAll('[data-kn-upload]');
  for (var i = 0; i < roots.length; i++) {
   try { setup(roots[i]); } catch (e) { log('error', e); }
  }
 };

 if (!KN.listening) {
  KN.listening = true;
  var run = function () { if (window.__knUpload3 && window.__knUpload3.initAll) window.__knUpload3.initAll(); };
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
 }
 if (document.readyState !== 'loading') KN.initAll();
})();
